import { render, staticRenderFns } from "./InstagramLink.vue?vue&type=template&id=1b684d7a&scoped=true"
var script = {}
import style0 from "./InstagramLink.vue?vue&type=style&index=0&id=1b684d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b684d7a",
  null
  
)

export default component.exports